import { render, staticRenderFns } from "./verify-email-dailog.vue?vue&type=template&id=56f234bd&scoped=true&"
import script from "./verify-email-dailog.vue?vue&type=script&lang=js&"
export * from "./verify-email-dailog.vue?vue&type=script&lang=js&"
import style0 from "./verify-email-dailog.vue?vue&type=style&index=0&id=56f234bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f234bd",
  null
  
)

export default component.exports